import React, { useState, useEffect } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ProjectBanner = ({ project }) => {
  const [checkingAdmin, setCheckingAdmin] = useState(false);

  useEffect(() => {
    console.log("📦 ProjectBanner received:", project);
  }, [project]);

  if (!project) return null;

  const handleClick = async () => {
    // 🔍 Log before returning
    console.log("🧭 Navigating for project:", project);
    console.log("🆔 project.id:", project?.id);

    if (!project?.id) {
      alert("⚠️ Missing project ID — cannot navigate yet.");
      return;
    }

    setCheckingAdmin(true);

    try {
      const token = localStorage.getItem("token");
      const userEmail = localStorage.getItem("userEmail");
      if (!token || !userEmail) {
        alert("Unauthorized: Please log in.");
        return;
      }

      // 🔹 Admin check
      const response = await fetch(`${BACKEND_URL}/projects/${project.id}/admin-view`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
      console.log("🔍 Admin check result:", data);

      if (response.ok && data.isAdmin) {
        window.location.href = `https://frontera.app/projects/${project.id}/admin-view`;
        return;
      }

      // 🔹 Membership check
      const membershipResponse = await fetch(
        `${BACKEND_URL}/projects/${project.id}/members/${userEmail}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const membershipData = await membershipResponse.json();
      console.log("👥 Membership check result:", membershipData);

      if (membershipResponse.ok && membershipData.isTeamMember) {
        window.location.href = `https://frontera.app/projects/${project.id}/collaborate`;
      } else {
        window.location.href = `https://frontera.app/projects/${project.id}/details`;
      }
    } catch (err) {
      console.error("❌ ProjectBanner navigation error:", err);
      window.location.href = `https://frontera.app/projects/${project.id}/details`;
    } finally {
      setCheckingAdmin(false);
    }
  };

  return (
    <div
      onClick={handleClick}
      className="relative w-full cursor-pointer rounded-2xl overflow-hidden 
                 border border-blue-100 bg-gradient-to-r from-sky-50 via-white to-blue-50 
                 shadow-md hover:shadow-xl transition-all duration-300 
                 hover:-translate-y-1 hover:scale-[1.01] group"
    >
      <div className="absolute inset-0 bg-gradient-to-tr from-blue-100/50 to-sky-200/30 blur-2xl" />
      <div className="relative flex items-center gap-4 p-5">
        <div className="flex-shrink-0 h-16 w-16 rounded-xl overflow-hidden border border-gray-200 shadow-sm group-hover:shadow-md transition">
          {project.image ? (
            <img
              src={project.image}
              alt={project.title}
              className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-300"
            />
          ) : (
            <div className="h-full w-full flex items-center justify-center bg-gradient-to-br from-sky-200 to-blue-300 text-white font-bold text-lg">
              {project.title?.[0] || "P"}
            </div>
          )}
        </div>

        <div className="flex flex-col">
          <h2 className="text-lg font-bold text-gray-900 tracking-tight">
            {project.title}
          </h2>
          {project.oneLiner && (
            <p className="text-sm text-gray-600 mt-0.5">{project.oneLiner}</p>
          )}
        </div>
      </div>

      <div className="relative bg-gradient-to-r from-blue-600 to-sky-500 px-5 py-2">
        <p className="text-xs font-medium text-white">
          {checkingAdmin
            ? "Checking access…"
            : "Your project has been created successfully"}
        </p>
      </div>
    </div>
  );
};

export default ProjectBanner;
